import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ReturnsService } from 'src/app/sales/returns/returns.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-return-line-item-tabs',
  templateUrl: './return-line-item-tabs.component.html',
  styleUrls: ['./return-line-item-tabs.component.scss']
})
export class ReturnLineItemTabsComponent implements OnInit, OnDestroy {

  @Input() soHeadId: number;
  @Input() soItemId: number;

  // states
  showCustomSelectionsTab = false;

  // subscriptions
  private _returnItemSub: Subscription;

  constructor(
    private _returnsSvc: ReturnsService
  ) { }

  ngOnInit() {

    this._returnItemSub = this._returnsSvc.ReturnItem.subscribe((res: any) => {
      this.showCustomSelectionsTab = res.ModelType === 6 || res.ModelType === 7;
    });

  }

  ngOnDestroy() {

    if (this._returnItemSub) {
      this._returnItemSub.unsubscribe();
    }

  }

}
